import styled from '@emotion/styled';

export const SCard = styled.div`
  width: 364px;
  background: white;
  padding: 20px;
  margin: 20px;
`;

export const SWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000000;
  margin-bottom: 23px;
  & a {
    color: black;
  }
`;

export const SErrorMessage = styled.div`
  color: #F5222D;
  padding: 14px 0 20px;
`;
